import { ArrowUpRight } from "lucide-react";
import Logo from "@/components/Logo";
import Reveal from "@/components/Reveal";
import { NAV_ITEMS, LINKS, scrollToSection } from "@/data/content";

export default function Footer() {
  return (
    <footer data-testid="footer-section" className="bg-[#0B1120] text-white pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <div className="rounded-3xl border border-white/10 bg-[#121A2D] p-8 sm:p-12 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
            <div className="max-w-xl">
              <p className="font-mono text-[11px] tracking-[0.35em] text-[#00E5A3] mb-4">SUA PRÓXIMA VIAGEM</p>
              <p className="text-white/80 text-base sm:text-lg leading-relaxed">
                Me conte quando pretende viajar, quantas pessoas vão com você e qual é o seu investimento. Vamos
                encontrar uma proposta que combine com o seu perfil.
              </p>
            </div>
            <a
              href={LINKS.proximaViagem}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-quote-btn"
              className="shrink-0 inline-flex items-center gap-2 rounded-full bg-[#FF5A36] text-white font-semibold px-7 py-3.5 hover:bg-[#00E5A3] hover:text-[#0B1120] transition-colors duration-300"
            >
              Solicitar cotação
              <ArrowUpRight size={18} />
            </a>
          </div>
        </Reveal>

        <div className="mt-16 flex flex-col md:flex-row md:items-center md:justify-between gap-8 border-t border-white/10 pt-10">
          <div className="flex items-center gap-3">
            <Logo size={26} testid="footer-logo-mark" />
            <span className="leading-none">
              <span className="block font-display font-extrabold tracking-tight text-sm">JOÃO GARCEZ</span>
              <span className="block font-mono text-[9px] tracking-[0.35em] text-white/50 mt-1">TRAVEL DESIGNER</span>
            </span>
          </div>
          <nav className="flex flex-wrap gap-x-7 gap-y-3" aria-label="Navegação do rodapé">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                data-testid={`footer-${item.testid}`}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection(item.href);
                }}
                className="text-sm text-white/60 hover:text-[#00E5A3] transition-colors duration-300"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>

        <p className="mt-10 text-center text-xs text-white/40">
          © 2026 João Garcez · Travel Designer. Todos os direitos reservados.
        </p>
      </div>
    </footer>
  );
}
